<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ack"> </p>
<p class="FMH"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><span class="ePub-B">ACKNOWLEDGMENTS</span></span></p>
<p class="FMTNI">To the extensive libraries of H. G. Wells and Edgar Rice Burroughs, so helpful to an author with some very strange questions.</p>
<p class="FMTX">Also, for Albert Einstein, someday they will prove that you were one of them all along!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?e564b464